import AddCircleOutlinedIcon from "@mui/icons-material/AddCircleOutlined";
import {
  Checkbox,
  DialogTitle,
  FormControlLabel,
  Grid,
  Tooltip,
} from "@mui/material";
import { FormikErrors } from "formik";
import { FeedGroupInput } from "graphql/generated/schema-types";
import { ChangeEvent, Dispatch, SetStateAction } from "react";
import { StyledAddFeedGroupButton } from "./AddFeedTask.Styled";
import { DayToggle } from "./DayToggle";
import { GroupDropdown } from "./GroupDropdown";

export interface FeedGroupsHeaderProps {
  createFeedGroupRow: () => void;
  feedDay: string;
  groupId: number | undefined | null;
  setFeedDay: Dispatch<SetStateAction<string>>;
  setFieldValue: (
    field: string,
    value: string,
    shouldValidate?: boolean | undefined,
  ) =>
    | Promise<void>
    | Promise<FormikErrors<{ feedGroupArray: FeedGroupInput[] }>>;
  setGroupId: Dispatch<SetStateAction<number | null | undefined>>;
  selectedCount: number;
  selectableCount: number;
  setAllFeedGroupsSelected: (selected: boolean) => void;
}

export const FeedGroupHeader = (props: FeedGroupsHeaderProps) => {
  const handleGroupChange = (event: ChangeEvent<unknown>, newValue: any) => {
    props.setGroupId(newValue.groupId);
    props.setFieldValue("groupId", newValue.groupId);
  };

  const allSelected =
    props.selectableCount > 0 && props.selectedCount === props.selectableCount;
  const someSelected =
    props.selectedCount > 0 && props.selectedCount < props.selectableCount;

  return (
    <Grid container spacing={0} sx={{ mb: 4, ml: 0.5 }}>
      <Grid item xs={2.4}>
        <DialogTitle>Feed Groups</DialogTitle>
      </Grid>
      <Grid item xs={1.35} sx={{ mr: 3 }}>
        <StyledAddFeedGroupButton onClick={props.createFeedGroupRow}>
          <AddCircleOutlinedIcon sx={{ mr: 0.8 }} /> Add Group
        </StyledAddFeedGroupButton>
      </Grid>
      <Grid item xs={2} sx={{ mt: 0.5, mr: 3 }}>
        <GroupDropdown
          onChange={handleGroupChange}
          setGroupId={props.setGroupId}
          value={props.groupId}
        />
      </Grid>
      <Grid item xs={2} sx={{ mt: 1 }}>
        <Tooltip title="Choose which feed groups get a task today or tomorrow">
          <FormControlLabel
            control={
              <Checkbox
                size="small"
                checked={allSelected}
                indeterminate={someSelected}
                disabled={props.selectableCount === 0}
                onChange={(e) =>
                  props.setAllFeedGroupsSelected(e.target.checked)
                }
                inputProps={{ "aria-label": "Select all feed groups" }}
              />
            }
            label={`${props.selectedCount} of ${props.selectableCount} selected`}
          />
        </Tooltip>
      </Grid>
      <DayToggle setFeedDay={props.setFeedDay} feedDay={props.feedDay} />
    </Grid>
  );
};
